export default "__VITE_ASSET__bbbd640c__"